<template>
  <div class="main_container">
    <div class="content_mc_wrp">
      <div class="container-fluid" v-cloak>
        <div class="header__nav">
          <!-- s -->
          <!-- <RouteMap v-if="crumbs.length > 0" :mapRoutes="crumbs" /> -->
          <div v-if="navTabs" class="tabs_container">
            <NavTab
              v-for="(tab, index) in navTabs"
              :key="index"
              v-bind="tab"
              :active="tab.key == $route.name || $route.params && $route.params.asset && $route.params.asset == tab.key "
            />
          </div>
          <!-- <ol class="breadcrumb mb-0 pl-0">
        <div class="container">
          <RouteMap :mapRoutes="crumbs" />
          <div class="tabs_container">
            <NavTab
              v-for="(tab, index) in navTabs"
              :key="index"
              v-bind="tab"
              :active="tab.key == $route.name"
            />
          </div>
           <ol class="breadcrumb mb-0 pl-0">
              <li class="breadcrumb-item" aria-current="page">
                <router-link to="/home"><i class="fa fa-home"></i></router-link>
              </li>
              <li class="breadcrumb-item" aria-current="page" v-for="(item, index) in crumbs" :key="index">
                <template v-if="item.path">
                  <router-link :to="{ name: item.path}">{{ item.name }}</router-link>
                </template>
                <template v-else>
                  {{ item.name == 'Dashboard' ? $route.query.title : '' }} {{ item.name }}
                </template>
              </li>
            </ol> -->
        </div>

        <router-view> </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import NavTab from "../components/global/NavTab.vue";
import RouteMap from "../components/global/RouteMap.vue";
import { db } from "../firebaseDB";

export default {
  components: { NavTab, RouteMap },
  data() {
    return {
      selectedStoryTitle: '',
      crumbs: [],
      tabs: {
        "user-info": [
          {
            text: "Owner Info",
            color: "primary",
            link: "/profile",
            key: "profile",
          },
          {
            text: "Email",
            color: "primary",
            link: "user-email",
            key: "user-email",
          },
          {
            text: "Security",
            color: "primary",
            link: "user-security",
            key: "user-security",
          },
        ],
        company: [

          {
            text: "Company Info",
            color: "primary",
            link: "/newprofile/company/company-info",
            key: "company-info",
          },
          {
            text: "Plans",
            color: "primary",
            link: "/newprofile/company/plans",
            key: "company-plans",
          },
          {
            text: "Billing",
            color: "primary",
            link: "/newprofile/company/billing",
            key: "company-billing",
          },

          {
            text: "Users",
            color: "primary",
            link: "/manage-users",
            key: "manageUsers",
          },
        ],
        assets : [
                  {
                    text: "3D Model",
                    color: "primary",
                    link: "/assets/3d-model",
                    key: "3d-model",
                  },
                  {
                    text: "Character Model",
                    color: "primary",
                    link: "/assets/character-model",
                    key: "character-model",
                  },
                  {
                    text: "Character Animation",
                    color: "primary",
                    link: "/assets/character-animation",
                    key: "character-animation",
                  },
                  {
                    text: "Visual Effect",
                    color: "primary",
                    link: "/assets/visual-effect",
                    key: "visual-effect",
                  },
                  {
                    text: "Voice",
                    color: "primary",
                    link: "/assets/voice",
                    key: "voice",
                  },
                  {
                    text: "Sound",
                    color: "primary",
                    link: "/assets/sound",
                    key: "sound",
                  },
                  {
                    text: "Video",
                    color: "primary",
                    link: "/assets/video",
                    key: "video",
                  },
                  {
                    text: "Images",
                    color: "primary",
                    link: "/assets/images",
                    key: "images",
                  },

        ]
      },
    };
  },
  mounted() {
    this.assignCrumbs(this.$route.name);
  },
  computed: {
    navTabs(){
      if(['user-email','user-security','profile'].includes(this.$route.name)) return this.tabs['user-info'];
      else if(['company-plans', 'company-info', 'manageUsers','company-billing'].includes(this.$route.name)) return this.tabs['company'];
      else if(this.$route.name == "assets") return this.tabs['assets'];
      return null
    }
  },
  methods: {
    assignCrumbs(routername) {
      this.crumbs = [];
      switch (routername) {
        //COMPANY
        case "profile":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "profile",
              name: "Profile",
            },
          ];
          break;
        case "company-plans":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "company-plans",
              name: "Plans",
            },
          ];
          break;
        case "company-billing":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "company-billing",
              name: "Billing",
            },
          ];
          break;
        case "manageUsers":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "manageUsers",
              name: "Owner Info",
            },
          ];
          break;
        case "company-info":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "company-info",
              name: "Company Info",
            },
          ];
          break;

        //USER INFO
        case "user-email":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "User Info",
            },
            {
              path: "user-email",
              name: "Email",
            },
          ];
          break;
        case "user-security":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "User Info",
            },
            {
              path: "user-security",
              name: "Security",
            },
          ];
          break;

        //PROJECTS
        case "add-story":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "add-story",
              name: "Add Story",
            },
          ];
          break;
        case "add-story-step-1":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "",
              name: "Add Story",
            },
            {
              path: "add-story-step-1",
              name: "Step 1",
            },
          ];
          break;
        case "add-story-step-2":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "",
              name: "Add Story",
            },
            {
              path: "add-story-step-1",
              name: "Step 1",
            },
            {
              path: "add-story-step-2",
              name: "Step 2",
            },
          ];
          break;

        // upload project
        case "update-story":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: "Dashboard",
            },
            {
              path: "settings",
              name: "settings",
            },
          ];
          break;
        case "update-story-step-1":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: "Dashboard",
            },
            {
              path: "",
              name: "settings",
            },
            {
              path: "update-story-step-1",
              name: "Step 1",
            },
          ];
          break;
        case "update-story-step-2":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: "Dashboard",
            },
            {
              path: "",
              name: "settings",
            },
            {
              path: "update-story-step-1",
              name: "Step 1",
            },
            {
              path: "update-story-step-2",
              name: "Step 2",
            },
          ];
          break;

        case "projects":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
          ];
          break;
        case "project-dashboard":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: `${this.selectedStoryTitle} Dashboard`,
            },
          ];
          break;
        case "comingsoon":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "",
              name: "Coming Soon",
            },
          ];
          break;

        case "assets":
          this.crumbs = [
            {
              path: "",
              name: "Assets",
            },
            {
              path: "assets/"+this.$route.params.asset,
              name: this.$route.params.asset,
            },
          ];
          break;
        case "userclass":
          this.crumbs = [
            {
              path: "userclass",
              name: "API Calls",
            },
          ];
          break;
        case "abxr-market":
          this.crumbs = [
            {
              path: "abxr-market",
              name: "ABXR Market",
            },
          ];
          break;
        case "support":
          this.crumbs = [
            {
              path: "support",
              name: "Support",
            },
          ];
          break;
        case "legal":
          this.crumbs = [
            {
              path: "legal",
              name: "Legal",
            },
          ];
          break;
        case "updates":
          this.crumbs = [
            {
              path: "updates",
              name: "Updates",
            },
          ];
          break;
      }
    },
    getStoryName() {
      let tRef = db.ref().child("stories/" + localStorage.getItem("storyId"));
      tRef.once('value')
        .then(snapshot => {
        let json = snapshot.val() && snapshot.val().json;
        if (json && json.storyName) {
          this.selectedStoryTitle = json.storyName;
          console.log(json.storyName);
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      this.assignCrumbs(to.name);
      this.getStoryName(to.name);
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs_container {
  display: flex;
  align-items: end;
  width: 100%;
  height: 6rem;
  padding: 1rem 0 0 0;
}
.container {
  padding: 0 30px !important;
}
// .header__nav {
//   padding-bottom: 1rem;
// }
</style>


// WEBPACK FOOTER //
// src/views/ProfileWrapper.vue